import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { WeighedMaterialType } from '../../../../constants/MaterialModels';
import AggDecumScale from './AggDecumScale';
import CemDecumScale from './CemDecumScale';

@observer
class DecumScale extends Component {
  render() {
    const { batchStore, materialStore, material, device } = this.props;
    const md = material ? materialStore.materialDetails[material.materialDetailId] || {} : {};
    const materialType = md.type;
    let materialTypeClass = '';
    if (md.type === WeighedMaterialType.FineAggregate) {
      materialTypeClass = 'fine-agg';
    } else if (md.type === WeighedMaterialType.CoarseAggregate) {
      materialTypeClass = 'coarse-agg';
    } else if (md.type === WeighedMaterialType.Cement) {
      materialTypeClass = 'material-cement';
    } else if (md.type === WeighedMaterialType.Cementitious) {
      materialTypeClass = 'material-cementitious';
    }
    const moisture = md.autoMoisture && md.autoMoistureAmount
      ? md.autoMoistureAmount
      : md.moistureAmount;
    const currentBalance = material ? materialStore.getDevicesBalance(material) : 0;

    const ports = batchStore.getScalePorts(device, md);
    const active = batchStore.isScaleOpen(device, ports.statusPort);

    if (materialType === WeighedMaterialType.FineAggregate || materialType === WeighedMaterialType.CoarseAggregate) {
      return (
        <AggDecumScale {...this.props}
          moisture={moisture}
          currentBalance={currentBalance}
          materialTypeClass={materialTypeClass}
          active={active}
          ports={ports}
        />
      );
    }

    return (
      <CemDecumScale {...this.props}
        currentBalance={currentBalance}
        materialTypeClass={materialTypeClass}
        active={active}
        ports={ports}
      />
    );
  }
}

export default DecumScale;
